import React, { useCallback, useEffect, useState } from "react";
import cn from "classnames";
import { createPortal } from "react-dom";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import styles from "./ModalProduct.module.sass";
import Icon from "../Icon";
import TextInput from "../TextInput";
import Card from "../Card";
import { showSuccess, showError } from "../../services/toast.service";
import { updateContract } from "../../services/contract.service";

const ModalEngageOpco = ({ visible, onClose, contractId, onEngagementUpdated }) => {
  const [numeroInterne, setNumeroInterne] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  // Réinitialiser le numéro interne quand la modal s'ouvre
  useEffect(() => {
    if (visible) {
      setNumeroInterne("");
    }
  }, [visible]);

  const escFunction = useCallback(
    (e) => {
      if (e.keyCode === 27) {
        onClose();
      }
    },
    [onClose]
  );

  const handleEngageOpco = async () => {
    if (!numeroInterne.trim()) {
      showError("Veuillez saisir un numéro interne");
      return;
    }

    if (!contractId) {
      showError("ID du contrat manquant");
      return;
    }
    
    try {
      setIsUpdating(true);
      
      console.log('Engagement OPCO - contractId:', contractId);
      console.log('Engagement OPCO - numeroInterne:', numeroInterne.trim());
      
      // Mettre à jour le contrat avec le numéro interne OPCO
      const result = await updateContract(contractId, {
        numero_interne: numeroInterne.trim()
      });

      console.log('Résultat mise à jour contrat:', result);
      showSuccess("Dossier OPCO engagé avec succès");
      
      if (typeof onEngagementUpdated === 'function') {
        onEngagementUpdated(numeroInterne.trim());
      }
      
      setTimeout(() => onClose(), 500);
    } catch (error) {
      console.error('Erreur lors de l\'engagement du dossier OPCO:', error);
      showError("Erreur lors de l'engagement du dossier OPCO: " + error.message);
    } finally {
      setIsUpdating(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  useEffect(() => {
    if (visible) {
      const target = document.querySelector("#modal-change-opco");
      disableBodyScroll(target);
    } else {
      clearAllBodyScrollLocks();
    }
  }, [visible]);

  return createPortal(
    visible && (
      <div id="modal-change-opco" className={styles.modal}>
        <div className={styles.control}>
          <button className={styles.close} onClick={onClose}>
            <Icon name="close" size="20" />
          </button>
        </div>
        <div className={styles.outer} style={{ position: 'relative' }}>
          <Card
            className={cn(styles.card)}
            title="Engager le dossier OPCO"
            classTitle="title-blue"
            style={{ minHeight: '400px', width: '600px', position: 'relative' }}
          >
            <div className={styles.description}>
              <div className={styles.field} style={{ marginBottom: '40px' }}>
                <h3 style={{ marginBottom: '20px', fontSize: '16px' }}>
                  Saisissez le numéro interne pour engager ce dossier OPCO :
                </h3>
                
                <TextInput
                  label="Numéro Interne"
                  name="numeroInterne"
                  type="text"
                  placeholder="Ex: 2025-001234"
                  required
                  value={numeroInterne}
                  onChange={(e) => setNumeroInterne(e.target.value)}
                />
              </div>
              
              <div className={styles.btnWrap} style={{ marginTop: '60px' }}>
                <button 
                  className="button-blue"
                  onClick={handleEngageOpco}
                  disabled={isUpdating || !numeroInterne.trim()}
                  style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}
                >
                  {isUpdating ? (
                    <>
                      <Icon name="loader" size="16" />
                      Engagement en cours...
                    </>
                  ) : (
                    <>
                      <Icon name="check" size="16" />
                      Engager le dossier
                    </>
                  )}
                </button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    ),
    document.body
  );
};

export default ModalEngageOpco;
